import Tooltip from "@mui/material/Tooltip";
import Image from "next/image";

import { cn } from "@/lib/utils";

interface IconCustomProps {
  src: any;
  width: number;
  height: number;
  alt: string;
  title?: string;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}
const IconCustom = (props: IconCustomProps) => {
  const inner = (
    <div
      className={cn(
        "transition-transform duration-150 ease-in-out",
        props.disabled ? "opacity-50" : "hover:scale-110 active:scale-95",
      )}
    >
      <Image
        src={props.src}
        width={props.width}
        height={props.height}
        alt={props.alt}
        className={cn(
          props.disabled ? "cursor-default" : "cursor-pointer",
          props.className,
        )}
        onClick={props.disabled ? () => {} : props.onClick}
        style={props.style}
      />
    </div>
  );

  if (props.title) {
    return (
      <Tooltip title={props.title} arrow>
        {inner}
      </Tooltip>
    );
  }

  return inner;
};

export default IconCustom;
